import { render } from "./GoodsListView.vue?vue&type=template&id=3c49f996"
import script from "./GoodsListView.vue?vue&type=script&lang=js"
export * from "./GoodsListView.vue?vue&type=script&lang=js"

import "./GoodsListView.vue?vue&type=style&index=0&id=3c49f996&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__